import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";

export default function PrivacyPolicy() {
  return (
    <div>
      <HeroSection
        title="Privacy Policy"
        description="How Toucan collects, uses, and protects your information."
        showSearchBar={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <PageHeader title="Privacy Policy" />

        <div className="mt-6 space-y-4 text-md text-gray-600 leading-relaxed">
          <p>
            Toucan collects information provided during account creation,
            bookings, communications, and platform use, including name, email,
            phone number, booking details, IP address, device data, and cookies.
          </p>

          <p>
            Information is used to operate the platform, facilitate bookings,
            process payments, prevent fraud, comply with legal obligations, and
            improve services.
          </p>

          <p>
            Information is shared with Vendors, payment processors, hosting
            providers, analytics providers, and as required by law.
          </p>

          <p>Toucan does not sell personal information.</p>

          <p>
            Information is retained as necessary for operational and legal
            purposes and protected using reasonable safeguards.
          </p>

          <p>The platform is not intended for children under 13.</p>

          <p>
            Contact:{" "}
            <a
              href="mailto:support@booktoucan.com"
              className="underline text-[#1FADC6]"
            >
              support@booktoucan.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
